module.exports = __webpack_public_path__ + "static/media/askelie-logo.89ed6361.PNG";